import moment from "moment";
import { constants } from "../constants";

class Utils {
  static loadImage = (url) => {
    return new Promise((resolve) => {
      const img = new Image();
      img.src = url;

      img.onload = () => resolve(url);
      img.onerror = () => resolve(false);
    });
  };

  static async apiRequest(
    url,
    method = "GET",
    body = null,
    onSuccess = () => {},
    onError = () => {}
  ) {
    try {
      const options = {
        method: method,
        headers: {
          "Content-Type": "application/json",
          // 'Authorization': 'Bearer ' + localStorage.getItem('token'),
        },
      };
      if (body) {
        options.body = JSON.stringify(body);
      }
      const response = await fetch(url, options);
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          `${response.status} ${response.statusText}: ${
            errorData?.message || "API request failed"
          }`
        );
      }
      const responseData = await response.json();
      onSuccess(responseData);
      alert("API request successful!");
      return responseData;
    } catch (error) {
      console.error("API Request Error:", error);
      alert(`API request failed: ${error.message}`);
      onError(error.message);
      throw error;
    }
  }

  static messageContent = (data) => {
    let content = "*Book Your Appointment*\n\n";

    if (data?.date)
      content += `• Date: ${moment(data.date).format("DD/MM/YYYY")}\n`;
    if (data?.time) content += `• Time: ${data.time}\n`;
    if (data?.name) content += `• Full Name: ${data.name}\n`;
    if (data?.contact) content += `• WhatsApp Number: ${data.contact}\n`;
    if (data?.baby_name) content += `• Baby's Name: ${data.baby_name}\n`;
    if (data?.address) content += `• Full Address: ${data.address}\n`;
    if (data?.photos) content += `• Photos: ${data.photos}\n`;
    if (data?.baby_dob) content += `• Baby's Date Of Birth: ${data.baby_dob}\n`;
    if (data?.category) content += `• Category: ${data.category}\n`;
    if (data?.package) content += `• Package: ${data.package}\n`;
    if (data?.pregnancy_month)
      content += `• Pregnancy Month: ${data.pregnancy_month}\n`;
    if (data?.reels) content += `• Reels: ${data.reels ? "YES" : "NO"}\n`;
    if (data?.twins) content += `• Twins: ${data.twins ? "YES" : "NO"}\n`;
    if (data?.baby_age) content += `• Baby's Age: ${data.baby_age}\n`;
    if (data?.email) content += `• Email: ${data.email}\n`;
    if (data?.message) content += `• Message: ${data.message}\n`;

    content += `\nCall us for more information: +91 9297929272`;

    return content;
  };

  static contactContent = (data) => {
    let content = "*INQUIRY*\n\n";

    if (data?.name) content += `*Full Name:* ${data.name}\n`;
    if (data?.email) content += `*Email:* ${data.email}\n`;
    if (data?.contact) content += `*WhatsApp Number:* ${data.contact}\n`;
    if (data?.message) content += `*Message:* ${data.message}\n`;

    return content;
  };

  static sendMessage = (data, type) => {
    const phoneNumber = constants.contact_number;
    const content =
      type === "contact"
        ? this.contactContent(data)
        : this.messageContent(data);
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
      content
    )}`;
    window.open(url, "_blank");
  };

  static getQueryParam = (param) => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    return urlParams.get(param);
  };

  static ImagePath = (path) => {
    return process.env.PUBLIC_URL + path;
  };

  static formatCurrency = (amount) => {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(amount);
  };

  static getFormattedDOBWithAge(dobString, type) {
    if (!dobString) return "";
  
    const dob = new Date(dobString);
    const today = new Date();
  
    const formattedDOB = `${String(dob.getDate()).padStart(2, "0")}-${String(
      dob.getMonth() + 1
    ).padStart(2, "0")}-${dob.getFullYear()}`;
  
    if (!type) {
      return formattedDOB;
    }
  
    let years = today.getFullYear() - dob.getFullYear();
    let months = today.getMonth() - dob.getMonth();
    let days = today.getDate() - dob.getDate();
  
    if (days < 0) {
      months--;
      const prevMonth = new Date(today.getFullYear(), today.getMonth(), 0);
      days += prevMonth.getDate();
    }
  
    if (months < 0) {
      years--;
      months += 12;
    }
  
    const yearStr = years === 1 ? "year" : "years";
    const monthStr = months === 1 ? "month" : "months";
    const dayStr = days === 1 ? "day" : "days";
  
    return `${formattedDOB} (${years} ${yearStr}, ${months} ${monthStr}, ${days} ${dayStr})`;
  }
  
}

export default Utils;
